import { cn } from "@/lib/utils";

import type { ReactNode } from "react";

export default function Container({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div className={cn("mx-auto max-w-7xl px-6 text-primary sm:px-4 md:px-2 lg:px-0", className)}>{children}</div>;
}
